export class ModelLog {
  constructor () {
    const currentEmployee = window.app.$store.getters.get('currentEmployee')

    this.id = null
    this.customerPOFollowUpID = null
    this.entryDate = new Date()
    this.employeeID = currentEmployee.id
    this.description = ''
    this.isEmployeeEntry = true
    this.isRead = false
  }
}

export const ModelCreateFromRFQPending = () => {
  return {
    id: null,
    rfqid: '',
    partID: null,
    partSN: '',
    reminderDate: null,
    lastInfo: '',
    orderPhaseID: '',
    orderPhasePersonInChargeEmployeeID: null,
    dateInPhase: null,
    priorityID: null,
    po: '',
    rfQ3ID: '',
    stockID: '',
    customerID: null,
    exchAgreementSigned: false,
    unitShipped: false,
    coreReceived: false,
    repairCostsApproved: false,
    unitReceivedCustomer: false
  }
}
